import React, {useCallback, useEffect, useState} from 'react';
import styled from 'styled-components/macro'
import {useWeb3React} from "@web3-react/core";
import { useParams } from "react-router-dom";
import moment from "moment";

import LandRegistration from '../artifacts/src/contracts/LandRegistration.sol/LandRegistration';
import ManagementCompany from '../artifacts/src/contracts/ManagementCompany.sol/ManagementCompany'
import LoanOriginator from '../artifacts/src/contracts/LoanOriginator.sol/LoanOriginator'
import LoanPool from '../artifacts/src/contracts/LoanPool.sol/LoanPool'

import companyLogo from '../assets/DAILogo.svg';
import Spinner from "./Spinner";

import AddLandModal from "./AddLandModal";
import useSortableData from "./UseSortableData";
import UpdateLandModal from "./UpdateLandInfoModal";
import LandAppraisalModal from "./UpdateLandAppraisalModal";
import AppraisalStatusViewModal from "./AppraisalStatusViewModal";
import DeleteLandConfirmationModal from "./DeleteLandConfirmationModal";
import CurrencyModal from "./CurrencyModal";

var BigNumber = require('big-number');

const DashboardPage = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    font-family: Lato;
    font-style: normal;
    z-index: 1;
    min-height: 100vh;
`

const SubTitle = styled.div`
    position: absolute;
    width: 296px;
    height: 25px;
    left: 10%;
    top: 116px;
    padding: 0px;

    font-weight: bold;
    font-size: 17px;
    line-height: 180%;
    color: #F9FAFB;
    
    opacity: 0.4;
`

const Title = styled.div`
    height: 54px;

    font-weight: bold;
    font-size: 40px;
    line-height: 180%;
    /* identical to box height, or 54px */

    text-transform: capitalize;

    color: #000000;
`

const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    justify-content: center;

    width: 80%;
    margin-left: 10%;
    margin-top: 40px;
`

const UpperTableContainer = styled.div`
    width: 100%;
    min-height: 600px;
`

const LowerTableContainer = styled.div`
    width: 100%;
    min-height: 300px;
`

const StyledTable = styled.table`
  border: none;
  border-collapse: separate;
  border-spacing: 0px 20px;
  width: 100%;
  min-width: 800px;
  font-weight: bold;

  thead {
    width: 100%;
    font-weight: bold;
    font-size: 20px;
    line-height: 180%;
    text-decoration: underline;
  }
    
  td, th {
    border: none;
    text-align: left;
    padding: 0px 10px;
  }

  tbody tr {
    width: 100%;
    height: 66px;
        
    background: #FFFFFF;
    box-shadow: 4px 6px 20px rgba(176, 176, 176, 0.15);
 
    :hover {
      background-color: #f5f5f5;
    }
  }
`;

const HeaderColumn = styled.button`
    font-weight: bold;
    font-size: 20px;
    border: none;
    background: transparent;
    text-decoration: underline;
    
    cursor: pointer;
`
const TitleNamePart = styled.div`
    position: absolute;
    width: 400px;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 100%;
    left: 10%;
    top: 197px;

    color: #FFFFFF;

`

const TitleInfoPart = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    line-height: 180%;
    right: 0;
    top: 197px;
    width: 50vw;
    height: 70px;
    
    @media all and (max-width: 1444px) {
        right: auto;
        padding-left: 0;
        margin-left: 567px;
        width: 800px;
}
`

const TitleInfoHeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    font-weight: bold;
    font-size: 18px;
    font-style: normal;
    color: rgba(255, 255, 255, 0.4);
    line-height: 18px;
`

const TitleInfoRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 8px;
    font-weight: bold;
    font-size: 24px;
    font-style: normal;
    color: #FFFFFF;
    line-height: 30px;
`


const TitleInfoItem = styled.div`
    width: 33%;
`

const HeaderText = styled.div`
      display: inline-block;
      margin-left: 15px;
      vertical-align: 50%;
`

const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
`

const ApprovalStatus = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 16px;
    
    position: static;
    width: 93px;
    height: 25px;
    
    background: #4AA900;
    border-radius: 40px;
    color: white;
`

const PendingStatus = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 16px;
    
    position: static;
    width: 93px;
    height: 25px;
    
    background: #FFCC2E;
    border-radius: 40px;
    color: white;
`

const DeveloperInfoPage = () => {
    const web3Context = useWeb3React();
    const [loading, setLoading] = useState(true);
    const [landRegistrationSC, setLandRegistrationSC] = useState({
        address: process.env.REACT_APP_LANDREGISTRATION_ADDRESS,
        abi: LandRegistration.abi
    });
    const [ManagementCompanySC, setManagementCompanySC] = useState({
        address: process.env.REACT_APP_MCADMIN_ADDRESS,
        abi: ManagementCompany.abi
    });
    const [LoanOriginatorSC, setLoanOriginatorSC] = useState({
        address: process.env.REACT_APP_LOANORIGINATOR,
        abi: LoanOriginator.abi
    });

    const currencies = CurrencyModal();

    const [boardMembers, setBoardMembers] = useState([]);

    const [companyName, setCompanyName] = useState("");
    const [location, setLocation] = useState("");
    const [note, setNote] = useState("");
    const [loanLimit, setLoanLimit] = useState(0);
    const [loanBalance, setLoanBalance] = useState(0);

    const [activeLands, setActiveLands] = useState([]);
    const [activeLoanEntities, setActiveLoanEntities] = useState();

    const { developerId } = useParams();

    const { items, requestSort, sortConfig } = useSortableData(activeLands);

    const loadLoanEntities = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );
        const loanOriginatorContract = new ethLibrary.Contract(
            LoanOriginatorSC.abi,
            LoanOriginatorSC.address
        );

        const UniqueLoanEntityIds = await landRegistrationContract.methods
            .getMyUniqueLoanEntityID(developerId)
            .call();

        let loanPoolId;
        let loanEntityId;

        let loanPoolAddress;
        let LoanPoolContract;

        let loanEntityInfoArray = [];
        let newLoanEntityObject = {};
        let loadedDetailsArray = [];

        for(var i = 1; i < UniqueLoanEntityIds.length; i++) {
            if(UniqueLoanEntityIds[i] === "0")
            {
                continue;
            }

            // eslint-disable-next-line no-undef
            const uintNumber = BigInt.asIntN(256, UniqueLoanEntityIds[i]);

            loanPoolId = uintNumber >> 128n;
            // eslint-disable-next-line no-undef
            loanEntityId = uintNumber & ((BigInt.asIntN(256, 1n) << 128n) - 1n);

            loanPoolAddress = await loanOriginatorContract.methods
                .getLoanPoolByID(loanPoolId)
                .call();

            LoanPoolContract = new ethLibrary.Contract(
                LoanPool.abi,
                loanPoolAddress
            );

            loanEntityInfoArray = await LoanPoolContract.methods
                .getLoanEntityViewByLoanEntityID(loanEntityId)
                .call();

            const loanPoolInfoArray = await LoanPoolContract
                .methods
                .getLoanPoolInfo()
                .call();

            const reloadedLoanPoolCurrency = loanPoolInfoArray[7];
            const currency = currencies.find(c => c.address.toLowerCase() === reloadedLoanPoolCurrency.toString().toLowerCase());
            const decimal = currency === undefined ? 18 : currency.decimal;

            newLoanEntityObject = {
                loanID: Number(loanEntityId),
                loanPoolName: loanEntityInfoArray[0],
                landAddress: loanEntityInfoArray[3],
                interestRateAPY: loanEntityInfoArray[4],
                closeDate: new Date(parseInt(loanEntityInfoArray[5]) * 1000).toISOString().slice(0,10),
                principle: loanEntityInfoArray[6] / (10 ** decimal),
                projectType: loanEntityInfoArray[7]
            };

            loadedDetailsArray.push(newLoanEntityObject);
        }

        setActiveLoanEntities(loadedDetailsArray);

    }, [web3Context, landRegistrationSC, LoanOriginatorSC]);

    const loadBoardMembers = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const ManagementCompanyContract = new ethLibrary.Contract(
            ManagementCompanySC.abi,
            ManagementCompanySC.address
        );

        const activeBoardMembers = await ManagementCompanyContract.methods
            .getActiveMCBoard()
            .call();

        setBoardMembers(activeBoardMembers.slice(1));
    }, [web3Context, ManagementCompanySC]);

    const loadDeveloperInfo = useCallback(async() => {
        // one developer information returned as an array
        let developerInfoArray = [];
        // land Id array stored in the developer

        if(developerId !== undefined && developerId !== null && developerId !== 0) {
            const ethLibrary = web3Context.library.eth;
            const landRegistrationContract = new ethLibrary.Contract(
                landRegistrationSC.abi,
                landRegistrationSC.address
            );
            developerInfoArray = await landRegistrationContract
                .methods
                .getDeveloperByID(developerId)
                .call();

            const newActiveLandIds = await landRegistrationContract
                .methods
                .getActiveLandIdsByDeveloperId(developerId)
                .call();

            setCompanyName(developerInfoArray[0]);
            setLocation(developerInfoArray[1]);
            setNote(developerInfoArray[2]);
            //developer Id
            setLoanLimit(developerInfoArray[4]);
            setLoanBalance(developerInfoArray[5]);

            let activeLandInfoArray = [];
            let votedAddressesArray = [];
            let newLandObject = {}
            let loadedDetailsArray = [];
            for(var i = 1; i < newActiveLandIds.length; i++) {
                activeLandInfoArray = await landRegistrationContract.methods.getLandByID(newActiveLandIds[i]).call();
                votedAddressesArray = await landRegistrationContract.methods.getVotedAddressByLandID(newActiveLandIds[i]).call();

                newLandObject = {
                    landID: newActiveLandIds[i],
                    // basic info
                    propertyIdentificationNumber: activeLandInfoArray[0],
                    propertyAddress: activeLandInfoArray[1],
                    propertyZoning: activeLandInfoArray[2],
                    note: activeLandInfoArray[3],
                    isReady: activeLandInfoArray[4],
                    votedAddressesArray: votedAddressesArray,
                    // uint    landID; --5
                    // uint    developerID; --6
                    appraisalAmount: activeLandInfoArray[7],
                    appraisalDiscountPercent: activeLandInfoArray[8],
                    amountBorrowedByDeveloper: activeLandInfoArray[9]
                }

                loadedDetailsArray.push(newLandObject);
            }

            setActiveLands(loadedDetailsArray);
        }
    }, [landRegistrationSC, web3Context]);

    const addNewLand = useCallback(async (propertyId, landAddress, zoning, note) => {
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );
        await landRegistrationContract.methods
            .addNewLand(propertyId, landAddress.toString(), zoning.toString(), note.toString(), developerId)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [landRegistrationSC, web3Context]);

    const updateLandInfo = useCallback(async (landId, propertyId, landAddress, zoning, note) => {
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );
        await landRegistrationContract.methods
            .updateLandBasicInfo(landId, propertyId, landAddress.toString(), zoning.toString(), note.toString())
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [landRegistrationSC, web3Context]);

    const updateAppraisal = useCallback(async (landId, appraisalValue, collateralFactor) => {
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );
        const exactNumber =  web3Context.library.utils.toBN(appraisalValue);

        await landRegistrationContract.methods
            .addOrUpdateLandAppraisal(landId, exactNumber, collateralFactor)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [landRegistrationSC, web3Context]);

    const approveAppraisal = useCallback(async (landId, appraisalValue, collateralFactor) => {
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );
        await landRegistrationContract.methods
            .approveLandAppraisal(landId)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [landRegistrationSC, web3Context]);

    const deleteLand = useCallback(async (landId) => {
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );
        await landRegistrationContract.methods
            .deleteLand(landId)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [landRegistrationSC, web3Context]);

    const loadSCAddress = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const MCAdminContract = new ethLibrary.Contract(
            ManagementCompany.abi,
            process.env.REACT_APP_MCADMIN_ADDRESS
        );

        const LRSC = await MCAdminContract.methods.LRSCAddress().call();

        setLandRegistrationSC({
            address: LRSC,
            abi: LandRegistration.abi
        });

        const LOSC = await MCAdminContract.methods.LOSCAddress().call();

        setLoanOriginatorSC({
            address: LOSC,
            abi: LoanOriginator.abi
        });


    }, [web3Context]);

    useEffect(() => {
        if (web3Context.active) {
            loadSCAddress();
            loadBoardMembers();
            loadDeveloperInfo();
            loadLoanEntities();
            setLoading(false);
        }
    }, [web3Context]);

    return (
        <DashboardPage>
            <SubTitle>Land > {companyName}</SubTitle>
            <TitleNamePart><img src={companyLogo} style={{width: "60px"}}/><HeaderText>{companyName}</HeaderText></TitleNamePart>
            <TitleInfoPart>
                <TitleInfoHeaderRow>
                    <TitleInfoItem>Location</TitleInfoItem>
                    <TitleInfoItem>Loan Limit</TitleInfoItem>
                    <TitleInfoItem>Loan Balance</TitleInfoItem>
                </TitleInfoHeaderRow>
                <TitleInfoRow>
                    <TitleInfoItem>{location}</TitleInfoItem>
                    <TitleInfoItem>${loanLimit}</TitleInfoItem>
                    <TitleInfoItem>${loanBalance}</TitleInfoItem>
                </TitleInfoRow>
            </TitleInfoPart>
            <FlexContainer>
                <Title>Land List For {companyName}</Title>
                <AddLandModal action={addNewLand} />
                <UpperTableContainer>
                    <StyledTable>
                        <thead>
                        <tr>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('propertyIdentificationNumber')}>Property ID
                                    <span>{sortConfig !== null && sortConfig.key === 'propertyIdentificationNumber' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('propertyAddress')}>Address
                                    <span>{sortConfig !== null && sortConfig.key === 'propertyAddress' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('appraisalAmount')}>Appraisal Value
                                    <span>{sortConfig !== null && sortConfig.key === 'appraisalAmount' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th >
                                <HeaderColumn
                                    onClick={() => requestSort('appraisalDiscountPercent')}>Collateral Factor
                                    <span>{sortConfig !== null && sortConfig.key === 'appraisalDiscountPercent' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th >
                                <HeaderColumn
                                    onClick={() => requestSort('propertyZoning')}>Zoning
                                    <span>{sortConfig !== null && sortConfig.key === 'propertyZoning' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th >
                                <HeaderColumn
                                    onClick={() => requestSort('isReady')}>Status
                                    <span>{sortConfig !== null && sortConfig.key === 'isReady' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th >
                                <HeaderColumn
                                    onClick={() => requestSort('amountBorrowedByDeveloper')}>Loan Balance
                                    <span>{sortConfig !== null && sortConfig.key === 'amountBorrowedByDeveloper' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th >
                                Action
                            </th>
                        </tr>
                        </thead>
                        <tbody >
                        {items === undefined ? (<Spinner/>) : items.map((land, index) => {
                            return (
                                <tr key={index} >
                                    <td>{land.propertyIdentificationNumber}</td>
                                    <td>{land.propertyAddress.length <= 10 ? land.propertyAddress : land.propertyAddress.substring(0,10) + "..."}</td>
                                    <td>${land.appraisalAmount}</td>
                                    <td>{land.appraisalDiscountPercent}%</td>
                                    <td>{land.propertyZoning}</td>
                                    <td>{land.isReady ? (<ApprovalStatus>APPROVED</ApprovalStatus>) : (<PendingStatus>PENDING</PendingStatus>)}</td>
                                    <td>${land.amountBorrowedByDeveloper}</td>
                                    <td>
                                        <ButtonRow>
                                            <AppraisalStatusViewModal
                                                landID = {land.landID}
                                                action ={approveAppraisal}
                                                header = {"Land: " + land.propertyAddress.length <= 30 ? land.propertyAddress : land.propertyAddress.substring(0,30) + "..."}
                                                boardMembers = {boardMembers}
                                                votingResults = {land.votedAddressesArray}
                                                caller={web3Context.account}
                                                landIsReady = {land.isReady}
                                            />
                                            <UpdateLandModal
                                                landID = {land.landID}
                                                landPropertyID = {land.propertyIdentificationNumber}
                                                landAddress = {land.propertyAddress}
                                                landZoning = {land.propertyZoning}
                                                note = {land.note}
                                                action ={updateLandInfo}
                                            />
                                            <LandAppraisalModal
                                                landID = {land.landID}
                                                landAddress = {land.propertyAddress}
                                                appraiseValue = {land.appraisalAmount}
                                                collateralFactor = {land.appraisalDiscountPercent}
                                                action = {updateAppraisal}
                                            />
                                            <DeleteLandConfirmationModal
                                                landID={land.landID}
                                                header={"Delete Land " + land.propertyAddress.length <= 30 ? land.propertyAddress : land.propertyAddress.substring(0,30) + "..." + "?"}
                                                message={'Are you sure that you want to delete land "' + land.propertyAddress + '"?'}
                                                note={"Note: All loans tied to the land must be paid off or liquidated before the land is deleted. You must remove the land associated with the developer before the developer can be deleted."}
                                                actionLabel = {"Delete Land"}
                                                action={deleteLand}/>
                                        </ButtonRow>
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </StyledTable>
                </UpperTableContainer>
            </FlexContainer>
            <FlexContainer>
                <Title>Loan Generated For {companyName}</Title>
                <LowerTableContainer>
                    <StyledTable>
                        <thead>
                        <tr>
                            <th>
                                <HeaderColumn>Loan ID</HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn>Market</HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn>Land Collateral</HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn>Principal</HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn>Maturity</HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn>Rate</HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn>Project Type</HeaderColumn>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {activeLoanEntities === undefined ? (<Spinner/>) : activeLoanEntities.map((loanEntity, index) => {
                            return (
                                <tr key={index}>
                                    <td>{loanEntity.loanID}</td>
                                    <td>{loanEntity.loanPoolName}</td>
                                    <td>{loanEntity.landAddress}</td>
                                    <td>${loanEntity.principle}</td>
                                    <td>{loanEntity.closeDate}</td>
                                    <td>{loanEntity.interestRateAPY / 1000}%</td>
                                    <td>{loanEntity.projectType}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </StyledTable>
                </LowerTableContainer>
            </FlexContainer>
        </DashboardPage>
    );
}

export default DeveloperInfoPage;
